
import { Button, Modal, Spin } from "antd";
import React, { useCallback, useState } from "react";

import ErrorMessage from "../shared/messages/errorMessage";
import moment from "moment";
import apiCalls from "src/api/apiCalls";
import apis from "./apiCalls";

const ChatMessage = ({ message }) => {
    const { reply, repliedBy, repliedDate, isCustomer, docRepositories } = message;
    const [showPreviewModel, setShowPreviewModel] = useState(false);
    const [previewImg, setPreviewImg] = useState(null);
    const [errorMsgs, setErrorMsgs] = useState(null);
    const [fileType, setFileType] = useState(null);
    const [previewLoader, setPreviewLoader] = useState(false);
    const [previewError, setPreviewError] = useState(null);
    const formattedDate = moment.utc(repliedDate).local().format("hh:mm A")

    const handlePreview = async (id) => {
        setShowPreviewModel(true);
        setPreviewLoader(true);
        setPreviewError(null);
        try {
            let res = await apis.getFileURL(id);
            if (res.ok) {
                const base64String = res.data.result;
                const mimeType = getFileType(base64String);
                const fileWithPrefix = addMimeTypePrefix(base64String, mimeType);
                setPreviewImg(fileWithPrefix);
                setFileType(mimeType);
            } else {
                setPreviewError(apiCalls.isErrorDispaly(res));
            }
        } catch (error) {
            setPreviewError(apiCalls.isErrorDispaly(error.message));
        } finally {
            setPreviewLoader(false);
        }
    };


    const getFileType = (base64String) => {
        if (base64String?.startsWith("iVBOR")) return "image";
        if (base64String?.startsWith("/9j/")) return "image";
        if (base64String?.startsWith("JVBER")) return "pdf";
        return "unknown";
    };

    const addMimeTypePrefix = (base64String, fileType) => {
        if (fileType === "image") {
            const mimeType = base64String?.startsWith("iVBOR") ? "image/png" : "image/jpeg";
            return `data:${mimeType};base64,${base64String}`;
        }
        if (fileType === "pdf") {
            return `data:application/pdf;base64,${base64String}`;
        }
        return base64String;
    };

    const renderPreview = () => {
        switch (fileType) {
            case "image":
                return <img src={previewImg} alt="Preview" className="md:w-80 w-full mx-auto" style={{ maxWidth: "100%", maxHeight: "500px" }} />;
            case "pdf":
                return <iframe src={previewImg} width="600" height="500" title="PDF Preview" />;
            default:
                return <p className="text-subTextColor text-base font-medium">Unsupported file type</p>;
        }
    };

    const handleDownload = useCallback(() => {
        const link = document.createElement('a');
        link.href = previewImg;
        link.download = 'file';
        link.click();
    }, [previewImg])
    const closeError = useCallback(() => {
        setErrorMsgs(null)
    }, [])
    const closePreviewModel = useCallback(() => {
        setShowPreviewModel(false)
    }, [])
    const closePreviewError = useCallback(() => {
        setPreviewError(null)
    }, [])
    return (
        <div className={`flex items-start ${isCustomer ? "justify-start" : "justify-end"} gap-2 mb-3`}>
            {errorMsgs && (
                <div className="mb-4">
                    <ErrorMessage msg={errorMsgs} onClose={closeError} />
                </div>
            )}
            {!isCustomer && (
                <h6 className="bg-primaryColor rounded-md md:w-10 md:h-10 w-8 h-8 flex flex-shrink-0 items-center justify-center">
                    <span className="text-lightDark">{repliedBy?.charAt(0)?.toUpperCase()}</span>
                </h6>
            )}
            <div
                className={`border border-StrokeColor py-2 px-3.5 w-full relative ${isCustomer ? "triangle-left-top" : "triangle-right-top"
                    } rounded-5 chat-shadow-box`}
            >
                <h5 className="flex items-center justify-between text-subTextColor text-xs font-semibold capitalize">
                    {repliedBy}<span className="text-paraColor font-normal">{formattedDate}</span>
                </h5>
                <p className="text-paraColor md:text-sm text-xs font-normal capitalize">{reply}</p>

                {docRepositories && docRepositories.length > 0 && (
                    <div className="flex items-start gap-1 mt-2 p-2 bg-lightBg rounded-[2px]">
                        {docRepositories.map((doc) => (
                            <div key={doc.id} className="flex items-center">
                                <span className="icon doc-icon cursor-pointer"></span>
                                <div className="">
                                    <p
                                        className="text-primaryColor md:text-sm text-xs cursor-pointer xl:w-96 lg:w-44 md:w-56 w-44 text-ellipsis overflow-hidden whitespace-nowrap"
                                        onClick={() => handlePreview(doc?.id)}
                                    >
                                        {doc.fileName}
                                    </p>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>

            {isCustomer && (
                <h6 className="bg-primaryColor rounded-md md:w-10 md:h-10 w-8 h-8 flex flex-shrink-0 items-center justify-center">
                    <span className="text-lightDark text-base">{repliedBy?.charAt(0)?.toUpperCase()}</span>
                </h6>
            )}

            <Modal
                open={showPreviewModel}
                title="Preview"
                closeIcon={
                    <button className="btn-plane" onClick={closePreviewModel}>
                        <span className="icon close"></span>
                    </button>
                }
                onCancel={closePreviewModel}
                footer={[
                   <>
                   <div className="md:!flex !justify-end md:space-x-2 space-x-0">
                   <Button
                        key="close"
                        type="default"
                        onClick={closePreviewModel}
                        className="cancel-btn"
                    >
                        Close
                    </Button>,
                    <Button
                        key="download"
                        type="primary"
                        className="text-light-primaryColor primary-btn "
                        onClick={handleDownload}
                    >
                        Download
                    </Button>
                   </div>
                   </>
                ]}
            >
                {previewLoader && <Spin className="flex justify-center items-center text-center my-4" spinning={previewLoader}></Spin>}
                {previewError && (
                    <div className="mb-4">
                        <ErrorMessage msg={previewError} onClose={closePreviewError} />
                    </div>
                )}
                {!previewLoader && !previewError && renderPreview()}
            </Modal>
        </div>
    );
};

export default ChatMessage;
